import { REPORTS_ENDPOINT } from "../../constants";
import { baseApi } from "./base.api.required.stub";
const secretsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getSecretsServices: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/secrets/services`,
                params: data,
            }),
        }),
        getSecretsEndpoints: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/secrets/endpoints`,
                params: data,
            }),
        }),
        getSecrets: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/secrets`,
                params: data,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useLazyGetSecretsEndpointsQuery, useLazyGetSecretsServicesQuery, useGetSecretsQuery, } = secretsApi;
//# sourceMappingURL=secrets.api.js.map